
import Select, { SelectItem, SelectProps } from '../components/Select';
import { CompanyStatus } from '../common/interfaces/company.interface';

const StatusOptions: SelectItem<string>[] = [
    {
        key: CompanyStatus.ACTIVE,
        value: 'Activa'
    },
    {
        key: CompanyStatus.INACTIVE,
        value: 'Inactiva'
    },
];

type CompanyStatusSelectProps = Omit<SelectProps<string>, 'options'>;

const CompaniesStatusSelect = ({ selected, onChange, ...selectProps }: CompanyStatusSelectProps) => {
    return (
        <Select
            {...selectProps}
            placeholder={`Status`}
            options={StatusOptions}
            onChange={onChange}
            selected={selected}
        />
    );
};

export default CompaniesStatusSelect;
